<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-04
      	描述：插件中心-预约服务
      -->
  <div class="common-seach-wrap">

    <!--优惠券列表-->
    <Reserve v-if="activeName=='reserve'"></Reserve>

    <Store v-if="activeName=='store'"></Store>

    <Clerk v-if="activeName=='clerk'"></Clerk>

    <Sku v-if="activeName=='sku'"></Sku>

    <Setting v-if="activeName=='setting'"></Setting>

  </div>
</template>
<script>
  import bus from '@/utils/eventBus.js';
  import Reserve from './reserve/index';
  import Store from './store/index';
  import Sku from './sku/index';
  import Setting from './setting/index';
  import Clerk from './clerk/index';
  export default {
    components: {
      Reserve,
      Store,
      Sku,
      Setting,
      Clerk,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        form: {},
        /*参数*/
        param: {},
        /*当前选中*/
        activeName: 'reserve',
        /*切换数组原始数据*/
        sourceList: [
            {
                key: 'reserve',
                value: '预约管理',
                path:'/plus/reserve/reserve/index'
            },
            {
                key: 'store',
                value: '门店管理',
                path:'/plus/reserve/store/index'
            },
            {
                key: 'clerk',
                value: '店员业绩',
                path:'/plus/reserve/clerk/index'
            },
            {
                key: 'sku',
                value: 'sku管理',
                path:'/plus/reserve/sku/index'
            },
            {
                key: 'setting',
                value: '基础设置',
                path:'/plus/reserve/setting/index'
            }
        ],
        /*权限筛选后的数据*/
        tabList:[],
      };
    },
    created() {

      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res =>
      {
          this.activeName = res;
      });

      //发送类别切换
      let params = {
          active: this.activeName,
          list: this.tabList,
          tab_type:'reserve'
      }
      bus.$emit('tabData', params);

    },
    beforeDestroy () {
        //发送类别切换
        bus.$emit('tabData', {active: null,tab_type:'reserve', list: []});
        bus.$off('activeValue');
    },
    methods: {

      /*权限过滤*/
      authFilter(){
        let list=[];
        for(let i=0;i<this.sourceList.length;i++){
          let item=this.sourceList[i];
          if(this.$filter.isAuth(item.path)){
            list.push(item);
          }
        }
        return list;
      },

    }
  };
</script>

<style>
  .operation-wrap {
    height: 124px;
    border-radius: 8px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 30px 30px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
    background: #909399;
    background-size: 100% 100%;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/reserve/index.vue